import React from 'react';
import { Field,FieldTypes, Inscription } from '@common-fe/common-fe';

import { EMPTY_FIELD_VALUE,FieldState,FieldStateKey,PermissionKey, PermissionState } from '@/common/constants';
import { useAuthStore } from '@/modules/user/stores';

const useGetPermissionToEditOverridableField = (permissionKey?: PermissionKey, fieldStateKey?: FieldStateKey) => {
  const { overridablePropertiesPermissions, overridablePropertiesFieldState } = useAuthStore();

  if (!overridablePropertiesPermissions) return {};

  const permissionState = permissionKey ? overridablePropertiesPermissions?.[permissionKey] : PermissionState.EDIT;
  let fieldState = FieldState.MODIFIABLE;

  if (fieldStateKey && overridablePropertiesFieldState && overridablePropertiesFieldState[fieldStateKey]) {
    fieldState = overridablePropertiesFieldState[fieldStateKey];
  }

  if (permissionState === PermissionState.HIDE || fieldState === FieldState.HIDDEN) {
    return {
      type: FieldTypes.Node,
      node: <Inscription color="textBody">{EMPTY_FIELD_VALUE}</Inscription>,
      disabled: true,
      showRequireIcon: false,
      validator: undefined,
      value: undefined,
      defaultValue: undefined,
      isAbsent: true,
    } as Partial<Field>;
  }

  if (permissionState === PermissionState.VIEW || fieldState === FieldState.LOCKED) {
    return {
      disabled: true,
      showRequireIcon: false,
      validator: undefined,
    } as Partial<Field>;
  }

  return {};
};

export default useGetPermissionToEditOverridableField;
